export default __webpack_public_path__ + "cross-icon-blue.svg";